import { ENV } from '../../../config/runtimeEnv';
import { BloodTestSubCategory } from "../../../types/lab/BloodTestCatalogueTypes";
import { http } from "../../../lib/http/client";

const HEALTHCARE_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

export const fetchBloodTestCatalogue = async (): Promise<BloodTestSubCategory[]> => {
	const response = await http.get(`${HEALTHCARE_BASE_URL}/blood-test-catalogue`);
	return response.data.data ?? response.data;
};
